import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { getFontUrlName } from '../../helpers/fonts';
import { connect } from 'react-redux';
import './FontDescriptions.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class FontDescriptions extends Component {
  goToPairing(font, pairing) {
    const primaryName = getFontUrlName(font.name)
    const secondaryName = getFontUrlName(pairing)
    browserHistory.push('/' + primaryName + '+' + secondaryName);
  }

  render() {
    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    return (
      <div className="font-description-wrapper">
        <div className="left-description">
          <a href={primary.googleUrl}
            target="_blank"
            className="description-header"
            style={styles.primaryFont}>
            {primary.name}
          </a>
        </div>
        <div className="right-description">
          <a href={secondary.googleUrl}
            target="_blank"
            className="description-header"
            style={styles.secondaryFont}>
            {secondary.name}
          </a>
        </div>
        <div className="clear"></div>
      </div>
    )
  }
}

export default FontDescriptions = connect(mapStateToProps, undefined)(FontDescriptions);



// WEBPACK FOOTER //
// ./src/components/generator/FontDescriptions.jsx